class AixiongData {
    constructor(runtime) {
        this.socket = null;
        this.runMode = 1;
        this.adaptor = false;
        this.guiTovm = {
            state: false,
            method: '',
            data: ''
        };
        this.fnCallback = [];
        this.brainChartTimer = null;
        /**
         * Reference to the owning Runtime.
         * @type{!Runtime}
         */
        this.runtime = runtime;
        this.userInfor = {}
        this.mySocket = null; //统计socket

        this.handpyVMData = {
            timestamp: 0,
            data: {
                A: 'up',
                B: 'up',
                P: 'up',
                Y: 'up',
                T: 'up',
                H: 'up',
                O: 'up',
                N: 'up'
            }
        }
    }

    //清除脑科学定时器 
    clearBrainChartTimer() {
        if (this.brainChartTimer) {
            clearInterval(this.brainChartTimer)
            this.brainChartTimer = null;
        }
    }

    postData(data) {
        this.socket = data.socket;
        this.runMode = data.runMode;
        this.adaptor = data.adaptor;
        this.guiTovm = data.guiTovm;
        this.handpyVMData = data.handpyVMData;
        this.handpyMobileMsg = data.handpyMobileMsg;

        if (this.fnCallback.length) {
            for (let index = 0; index < this.fnCallback.length; index++) {
                if (this.fnCallback[index]) {
                    this.fnCallback[index]();
                }
            }
        }
    }

    getSocket() {
        return this.socket;
    }

    getMySocket() {
        return this.mySocket;
    }

    getRunMode() {
        return this.runMode;
    }

    getAdaptor() {
        return this.adaptor;
    }

    getGuiTovm() {
        return this.guiTovm;
    }

    getHandpyVMData() {
        return this.handpyVMData;
    }
}

module.exports = AixiongData;
